import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/index.html',
      name: 'index',
      component: home
    },
    {
      path: '/home',
      name: 'homeIndex',
      component: home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js